export const statisticsViewTypes = {
  OVERVIEW: 'Overview',
  SESSIONS: 'Sessions',
};
